import { render } from "./OrderForm.vue?vue&type=template&id=7b6b51b1&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=7b6b51b1&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6b51b1"]])

export default __exports__